/**
 * External dependencies.
 */
import { assign, has, isEmpty } from 'lodash';

/**
 * Internal dependencies.
 */
import { getBackgroundStyle, getTextStyle, updateBlock, addStyleTag, getSpacingStyleProperties } from '../../extensions/custom-styles';

function styling( props, selector = false, attributes = false ) {
	const { size, customSize, iconimgBorderRadius, blockAdvanceOptions, borderRadius, borderWidth } = attributes ? attributes : props.attributes;
	const { iconPadding } = blockAdvanceOptions;

	let css = '';
	selector = selector ? selector : `.gutenify-section-${ props.clientId } .gutenify-icon-wrapper`;

	css += getBackgroundStyle( blockAdvanceOptions, selector );
	css += getTextStyle( blockAdvanceOptions, selector );

	css += `${ selector }:hover {
		${ has( blockAdvanceOptions, 'hoverTextColor' ) && ! isEmpty( blockAdvanceOptions.hoverTextColor ) ? `color: ${ blockAdvanceOptions.hoverTextColor };` : '' }
		${ has( blockAdvanceOptions, 'hoverBackgroundColor' ) && ! isEmpty( blockAdvanceOptions.hoverBackgroundColor ) ? `background-color: ${ blockAdvanceOptions.hoverBackgroundColor };` : '' }
		${ has( blockAdvanceOptions, 'hoverBackgroundGradient' ) && ! isEmpty( blockAdvanceOptions.hoverBackgroundGradient ) ? `background: ${ blockAdvanceOptions.hoverBackgroundGradient };` : '' }
		${ has( blockAdvanceOptions, 'hoverBorderColor' ) && ! isEmpty( blockAdvanceOptions.hoverBorderColor ) ? `border-color: ${ blockAdvanceOptions.hoverBorderColor };` : '' }
	}`;

	css += `${ selector } {
		${ has( blockAdvanceOptions, 'borderColor' ) && ! isEmpty( blockAdvanceOptions.borderColor ) ? `border-color: ${ blockAdvanceOptions.borderColor };` : '' }
		${ borderWidth ? `border-width: ${ borderWidth }px;` : '' }
		${ borderWidth ? `border-style: solid;` : '' }
		${ borderRadius ? `border-radius: ${ borderRadius };` : '' }
		${ has( iconPadding, 'desktop' ) ? getSpacingStyleProperties( iconPadding.desktop ) : '' }
	}`;

	// console.log( getSpacingStyleProperties( iconPadding.desktop ) );

	css += `${ selector } i {
		font-size: ${ size }px;
	}`;

	if ( customSize ) {
		css += `${ selector } img {
			width: ${ size }px;
			max-width: ${ size }px;
		}`;
	}

	css += `${ selector } .gutenify-image-icon-content img {
		border-radius: ${ iconimgBorderRadius }px;
	}`;

	// if ( iconColor ) {
	// 	css += `${ selector } i {
	// 		color: ${ iconColor };
	// 	}`;
	// }

	return css;
}

const updateBlockStyle = ( data, props ) => {
	const attrs = assign( props.attributes, data );
	const css = styling( props, false, attrs );

	updateBlock( data, css, props );

	// Admin.
	const adminCss = styling( props, `#block-${ props.clientId } .gutenify-icon-wrapper` );
	addStyleTag( props, adminCss, `gutenify-block-${ props.clientId }-main`, true );
};

export { updateBlockStyle };
export default styling;
